import { AuthContainer, AuthHeader } from '../atoms';
import {
  VerifyStatusContainer,
  VerifyStatusSpinner,
  VerifyStatusSuccessContent,
  VerifyStatusSuccessIcon,
  VerifyStatusSuccessIconSvg,
  VerifyStatusTextCenter,
} from './styled';
import { theme } from '../../styles/theme';

export interface VerifyEmailStatusProps {
  status: 'verifying' | 'success' | 'error';
  error?: string;
  verifyingTitle?: string;
  successTitle?: string;
  successMessage?: string;
  errorTitle?: string;
}

/**
 * Email verification status display component (UI only, no business logic).
 */
export function VerifyEmailStatus({
  status,
  error,
  verifyingTitle = 'Verifying your email...',
  successTitle = 'Email Verified!',
  successMessage = 'Your email has been verified successfully. You can close this page and sign in to your app.',
  errorTitle = 'Verification Failed',
}: VerifyEmailStatusProps) {
  if (status === 'verifying') {
    return (
      <AuthContainer>
        <VerifyStatusContainer>
          <AuthHeader title={verifyingTitle} />
          <VerifyStatusSpinner />
        </VerifyStatusContainer>
      </AuthContainer>
    );
  }

  if (status === 'error') {
    return (
      <AuthContainer>
        <VerifyStatusContainer $stretch>
          <AuthHeader
            title={errorTitle}
            subtitle={`${error || 'The verification link is invalid or has expired.'} Please try again or contact support if the problem persists. You can close this page and return to your app.`}
          />
        </VerifyStatusContainer>
      </AuthContainer>
    );
  }

  // Success state
  return (
    <AuthContainer>
      <VerifyStatusContainer $stretch>
        <VerifyStatusSuccessContent>
          <VerifyStatusSuccessIcon>
            <VerifyStatusSuccessIconSvg>
              <svg
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M5 13l4 4L19 7" />
              </svg>
            </VerifyStatusSuccessIconSvg>
          </VerifyStatusSuccessIcon>
          <VerifyStatusTextCenter style={{ fontSize: '1.5rem', fontWeight: 600 }}>
            {successTitle}
          </VerifyStatusTextCenter>
          <VerifyStatusTextCenter style={{ color: theme.colors.textSecondary }}>
            {successMessage}
          </VerifyStatusTextCenter>
        </VerifyStatusSuccessContent>
      </VerifyStatusContainer>
    </AuthContainer>
  );
}
